import { format as formatDate, parse } from 'date-fns';

export default class LocaleHelper {
	public localeName: string;

	public parseDate(dateString: string, format?: string): Date | null {
		if (!dateString) {
			return null;
		}

		if (format) {
			return parse(dateString, format, 0);
		}

		return new Date(Date.parse(dateString));
	}

	public formatDate(date: Date, format: string): string {
		return formatDate(date, format);
	}

	public dateEquals(date1?: Date, date2?: Date, ignoreInvalid = true): boolean {
		const date1Value = date1?.valueOf();
		const date2Value = date2?.valueOf();
		if (ignoreInvalid && isNaN(date1Value) && isNaN(date2Value)) {
			return true;
		}

		return date1Value === date2Value;
	}
}
